import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { options } from "./../../utils/richTextOptions";

const SecondIntro = ({ title1, description1, title2, description2 }) => {
  return (
    <div className="px-5 2xl:px-[90px] py-[68px] 2xl:py-[90px] box-border text-black">
      <div className="max-w-[900px] w-full mx-auto relative mb-[30px]">
        <h2 className="text-xl md:text-3xl leading-[45px] md:leading-[60px] font-bold tracking-wide mb-5 text-black">
          {title1}
        </h2>
        <div className="mt-[10px] leading-7 tracking-wide text-left">
          {documentToReactComponents(JSON.parse(description1.raw), options)}
        </div>
      </div>
      {(title2 || description2) && (
        <div className="max-w-[800px] w-full mx-auto my-[30px] md:my-0 p-[30px] md:p-[50px] relative bg-black/5 rounded-[10px]">
          {title2 && (
            <h3 className="text-xl md:text-[25px] leading-[30px] md:leading-10 font-bold tracking-wide mb-[30px]">
              {title2}
            </h3>
          )}

          {description2 && (
            <div>
              {documentToReactComponents(JSON.parse(description2.raw), options)}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SecondIntro;
